<script setup lang="ts">
import {AlertsRun} from "@/medication-checkup/interfaces/alerts";

/**
 * The recap the Copilote gives of the run: the served line, and the word
 * for a run that raised nothing.
 */

defineProps<{run: AlertsRun}>();
</script>

<template>
  <div class="flex gap-2.5 items-start">
    <span
      class="w-[30px] h-[30px] mt-0.5 shrink-0 rounded-full flex items-center justify-center
             bg-gradient-to-r from-primary-dark to-primary"
    >
      <img src="@/assets/images/logos/apodis-white.svg" alt="Copilote" class="h-[15px]">
    </span>

    <div
      class="max-w-[75%] flex flex-col gap-2 bg-white border border-slate-200 px-4 py-2.5 text-sm leading-relaxed
             rounded-r-2xl rounded-bl-2xl rounded-tl shadow-sm"
    >
      <span>{{ run.summary.text }}</span>

      <span v-if="run.empty" class="text-xs text-muted-foreground">{{ run.empty }}</span>
    </div>
  </div>
</template>
